import { RG_TYPE } from '../../types/rg-type.js';
import { DefaultTechnicalSpaceRoom } from './default-technical-space-room.js';

const DefaultTechnicalSpace = {
    type: RG_TYPE.TechnicalSpace,
    color: '#E0E0CD',
    size: [3.0, 2.5, 7.5],
    anchor: [0.5, 0, 0.5],
    name: 'default technical space',
    children: [DefaultTechnicalSpaceRoom],
    data: {
        level: -1,
        levelId: '',
        muscleID: '',
        instance: {
            name: 'default space instance',
            source: '',
            attributes: {},
            conditions: {}
        }
    }
};

export { DefaultTechnicalSpace };
//# sourceMappingURL=default-technical-space.js.map
